<div class="card-expansion-panel" [ngClass]="{'toggled': toggled}">
    <div class="card-expansion-panel-header" (click)="toggle()">
        <div class="card-expansion-panel-header-title">
            <ng-content select="[header]"></ng-content>
        </div>
        <div class="icon-smash_expand_arrow card-expansion-panel-header-icon" [ngClass]="{'toggled': toggled}"></div>
    </div>
    <div class="card-expansion-panel-separator" [ngClass]="{'toggled': toggled}"></div>
    <div class="card-expansion-panel-content" [ngClass]="{'toggled': toggled}">
        <div class="card-expansion-panel-content-body">
            <ng-content select="[body]"></ng-content>
        </div>
    </div>
</div>